import chevRightRoyalIcon from "../../assets/images/chev-right-royal.svg";

export const footerLinks = [
  {
    text: 'Accessibility',
    iconSrc: chevRightRoyalIcon,
    iconClass: 'chev-icon',
    link: 'https://www.investec.com/en_gb/accessibility.html'
  },
  {
    text: 'Legal',
    iconSrc: chevRightRoyalIcon,
    iconClass: 'chev-icon',
    link: 'https://www.investec.com/en_gb/legal/UK.html'
  },
  {
    text: 'Know Fraud',
    iconSrc: chevRightRoyalIcon,
    iconClass: 'chev-icon',
    link: 'https://www.investec.com/en_gb/legal/know-fraud.html'
  },
  {
    text: 'Investor Relations',
    iconSrc: chevRightRoyalIcon,
    iconClass: 'chev-icon',
    link: 'https://www.investec.com/en_gb/welcome-to-investec/about-us/investor-relations.html'
  },
  {
    text: 'Modern Slavery Statement',
    iconSrc: chevRightRoyalIcon,
    iconClass: 'chev-icon',
    link: 'https://www.investec.com/en_gb/legal/modern-slavery-act-statement.html'
  }
];

